export default class Audio {

    constructor() {}

    init(game) {
        this.game = game;
        this.allMuted = false;
        this.isMusicPlaying = false;
        this.musicVolume = 0.5;
        this.sounds = {};

        this.tilePopBlocked = false;
        this.music = game.add.audio('backgroundMusic');
        this.sounds['tilePop'] = this.tilePop = game.add.audio('TilePop2');
        this.sounds['baddieGrunt'] = this.tilePop = game.add.audio('BaddieGrunt1');
        this.sounds['emptyLine'] = this.tilePop = game.add.audio('emptyLine');
        this.sounds['bombExplosion'] = this.bombExplosion = game.add.audio('PowerupPartyBombExplosion1');
        this.sounds['bombCharged'] = this.bombCharged = game.add.audio('bombCharged');
        this.sounds['buttonClick'] = this.buttonClick = game.add.audio('ButtonClick');
        this.sounds['success'] = this.success = game.add.audio('Success');
        this.sounds['gameOver'] = this.gameOver = game.add.audio('gameOver');
        this.sounds['time_15sec'] = this.time_15sec = game.add.audio('time_15sec');
        this.sounds['time_30sec'] = this.time_30sec = game.add.audio('time_30sec')
    }

    playMusic() {
        if (this.isMusicPlaying) { return; }
        this.music.volume = (this.allMuted) ? 0 : (this.musicVolume);
        this.isMusicPlaying = true;
        this.music.loop = true;
        this.music.play();
    }

    playSound(name) {
        if (name === 'tilePop' && this.tilePopBlocked) return;
        else if (name === 'tilePop') {
            this.tilePopBlocked = true;
            this.game.time.events.add(100, function () {
                AUDIO.tilePopBlocked = false
            })
        }

        var sound = this.sounds[name];
        sound.play();
    }

    muteAll() {
        this.allMuted = true;
        for (var key in this.sounds) {
            var sound = this.sounds[key];
            sound.volume = 0;
        }
        this.music.volume = 0;
    }

    unmuteAll() {
        this.allMuted = false;
        for (var key in this.sounds) {
            var sound = this.sounds[key];
            sound.volume = 1;
        }
        this.music.volume = this.musicVolume;
    }

    updateVolume() {
        if (this.allMuted || GS.pausedByArkadium) {
            this.muteAll();
        } else if (this.allMuted) {
            this.muteAll();
        } else {
            this.unmuteAll();
        }
    }

}
window.AUDIO = new Audio();
